import { type FC } from 'react';

import type { ApplicationCta, UserPreferencesAndMilitary } from '@core/blocks/best-match-experience/types';
import useDualCtaTest from '@core/hooks/useDualCtaTest';
import useProgramCode from '@core/hooks/useProgramCode';
import type { VoyagerResult } from '@core/ts/results';

import ApplicationCTA from '../../ApplicationCTA';
import ExitStrategyCongratsBanner from '../ExitStrategyCongratsBanner';
import ExitStrategyDrawerHeader from '../ExitStrategyDrawerHeader';
import styles from './ExitStrategySidebar.module.css';

type Props = {
  firstName: string;
  currentResultApplicationCta: ApplicationCta;
  isCurrentResultApplicationCtaLoading?: boolean;
  result: VoyagerResult;
  userPreferencesAndMilitary: UserPreferencesAndMilitary;
  showDrawerHeader?: boolean;
  isGrad?: boolean;
};

const ExitStrategySidebar: FC<Props> = ({
  firstName,
  isCurrentResultApplicationCtaLoading,
  currentResultApplicationCta,
  result,
  userPreferencesAndMilitary,
  showDrawerHeader = true,
  isGrad,
}) => {
  // fetch program code once program id is available
  const programCode = useProgramCode(result?.program?.id);

  const schoolId = result?.school?.id?.toString() || '';
  const { DualCtaTestComponent, shouldApplyWrapperStyles } = useDualCtaTest(schoolId, programCode);

  return (
    <section className={styles.exitStrategyContainer}>
      <div className={styles.congratsBanner}>
        {showDrawerHeader && (
          <ExitStrategyDrawerHeader
            isGrad={isGrad}
            result={result}
            userPreferencesAndMilitary={userPreferencesAndMilitary}
          />
        )}
        <ExitStrategyCongratsBanner firstName={firstName} />
      </div>
      <div className={shouldApplyWrapperStyles ? styles.dualCta : styles.singleCta}>
        <ApplicationCTA
          result={result}
          cta={currentResultApplicationCta}
          isLoading={isCurrentResultApplicationCtaLoading}
        />
        <DualCtaTestComponent schoolId={schoolId} />
      </div>
    </section>
  );
};

export default ExitStrategySidebar;
